//
//
//
//
//

export default {
  name: "top-header",
  data() {
    return {
    }
  },
  props:['text'],

  methods: {
    //注意wap
    backLastPage(){
      if(this.$store.state.device === 'wap'){
        this.$router.go(-1);
      }else{
        document.location = "http://action:10002/?";
      }
    },
  },

}



// WEBPACK FOOTER //
// ./src/components/top-header.vue